import { gsap } from "gsap";

const moves = document.querySelectorAll(".footer__entry,.header__fixedBtnsBtn,.cnt__rowModalInner>span")

moves.forEach((move) => {
    let state = false
    let duration = 2.5, timeScale = 5

    if (move.classList.contains("footer__entry")) {
        duration = 10
        timeScale = 6.666666666666666666666666666666666666
    }

    let anime = gsap.to(move.querySelectorAll(".mozinagashi>*"), {
        x: "-100%", overwrite: true, duration, ease: "linear", repeat: -1, paused: true,
        onRepeat: () => { if (!state) { anime.pause() } }
    })

    move.addEventListener("mouseenter", () => {
        if (window.innerWidth > 1024) {
            state = true
            anime.timeScale(1)
            anime.play()
        }
    })

    move.addEventListener("mouseleave", () => {
        if (window.innerWidth > 1024) {
            state = false
            anime.timeScale(timeScale)
            anime.reverse()
        }
    });
})